<template>
  <div class="row">
    <div class="form-group col-md-12 text-right">
      <button
        type="button"
        class="btn btn-success btn-sm mr-1"
        @click="exportarTarifas()"
        v-if="$store.getters.can('plantaEx.contratos.exportReporte')"
        title="Exportar tarifas a Excel (edición masiva)"
      >
        <i class="fas fa-file-excel"></i> Exportar
      </button>
      <button
        type="button"
        class="btn btn-info btn-sm mr-1"
        @click="abrirModalImportar()"
        v-if="$store.getters.can('plantaEx.contratos.edit')"
        title="Importar tarifas desde Excel"
      >
        <i class="fas fa-file-import"></i> Importar
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        data-toggle="modal"
        data-target="#modal_tarifa_crear"
        @click="getDatosModal()"
        v-if="$store.getters.can('plantaEx.contratos.edit')"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>

    <table
      class="
        table table-bordered table-striped table-hover
        text-nowrap
        table-sm
      "
      v-if="$parent.form"
    >
      <thead class="thead-dark">
        <tr>
          <th class="text-center">Tarifa</th>
          <th class="text-center">Tipo Producto</th>
          <th class="text-center">Tipo Vehículo</th>
          <th class="text-center">% Disponibilidad</th>
          <th class="text-center">Fecha Ini</th>
          <th class="text-center">Fecha Fin</th>
          <th class="text-center" style="width: 120px">Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tarifa, index) in $parent.form.tarifas" :key="tarifa.id">
          <td class="text-right">
            ${{
              tarifa.det_tarifas && tarifa.det_tarifas[0]
                ? tarifa.det_tarifas[0].tarifa
                : "—"
            }}
          </td>
          <td>
            {{
              tarifa.tipo_producto
                ? tarifa.tipo_producto.nombre
                : "—"
            }}
          </td>
          <td>
            {{
              tarifa.tipo_vehiculo ? tarifa.tipo_vehiculo.nombre : "—"
            }}
          </td>
          <td class="text-center">{{ tarifa.porcentaje_disponibilidad }}%</td>
          <td class="text-right">
            {{
              tarifa.det_tarifas && tarifa.det_tarifas[0]
                ? tarifa.det_tarifas[0].inicio_vigencia
                : "—"
            }}
          </td>
          <td class="text-right">
            {{
              tarifa.det_tarifas && tarifa.det_tarifas[0]
                ? tarifa.det_tarifas[0].fin_vigencia
                : "—"
            }}
          </td>
          <td class="text-right">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-sm bg-info"
                data-toggle="modal"
                data-target="#modal_tarifa_historico"
                @click="getDatosHistorico(tarifa, index)"
              >
                <i class="fas fa-history"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                data-toggle="modal"
                data-target="#modal_tarifa_actualizar"
                @click="getDatosModal(tarifa)"
                v-if="$store.getters.can('plantaEx.contratos.edit')"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="destroy(tarifa)"
                v-if="$store.getters.can('plantaEx.contratos.delete')"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Modal de Tarifa crear -->
    <div class="modal fade" id="modal_tarifa_crear">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Crear Tarifa</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-4">
                <label>Tipo de Producto</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.tipo_producto_id"
                  :class="
                    $v.form.tipo_producto_id.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="producto in $parent.listasForms.productos"
                    :key="producto.id"
                    :value="producto.id"
                  >
                    {{ producto.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Tipo de Vehículo</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.tipo_vehiculo_id"
                  :class="
                    $v.form.tipo_vehiculo_id.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_vehiculo in $parent.listasForms.tipos_vehiculo"
                    :key="tipo_vehiculo.id"
                    :value="tipo_vehiculo.id"
                  >
                    {{ tipo_vehiculo.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>% Disponibilidad</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  min="0"
                  max="100"
                  v-model="form.porcentaje_disponibilidad"
                  :class="
                    $v.form.porcentaje_disponibilidad.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div class="form-group col-md-4">
                <label>Valor Tarifa</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  min="0"
                  step="0.01"
                  v-model="form.tarifa"
                  :class="$v.form.tarifa.$invalid ? 'is-invalid' : 'is-valid'"
                />
              </div>
              <div class="form-group col-md-4">
                <label>Fecha Inicio</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form.inicio_vigencia"
                  :class="
                    $v.form.inicio_vigencia.$invalid ? 'is-invalid' : 'is-valid'
                  "
                  @change="validarFechas()"
                />
              </div>
              <div class="form-group col-md-4">
                <label>Fecha Fin</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form.fin_vigencia"
                  :class="
                    $v.form.fin_vigencia.$invalid ? 'is-invalid' : 'is-valid'
                  "
                  @change="validarFechas()"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              v-if="
                $store.getters.can('plantaEx.contratos.edit') &&
                  !$v.form.$invalid
              "
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Tarifa actualizar -->
    <div class="modal fade" id="modal_tarifa_actualizar">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Actualizar Tarifa</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-4">
                <label>Tipo de Producto</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form1.tipo_producto_id"
                  :class="
                    $v.form1.tipo_producto_id.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="producto in $parent.listasForms.productos"
                    :key="producto.id"
                    :value="producto.id"
                  >
                    {{ producto.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Tipo de Vehículo</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form1.tipo_vehiculo_id"
                  :class="
                    $v.form1.tipo_vehiculo_id.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_vehiculo in $parent.listasForms.tipos_vehiculo"
                    :key="tipo_vehiculo.id"
                    :value="tipo_vehiculo.id"
                  >
                    {{ tipo_vehiculo.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>% Disponibilidad</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  min="0"
                  max="100"
                  v-model="form1.porcentaje_disponibilidad"
                  :class="
                    $v.form1.porcentaje_disponibilidad.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                />
              </div>
              <div class="form-group col-md-4">
                <label>Valor Tarifa</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  min="0"
                  step="0.01"
                  v-model="form1.tarifa"
                  :class="$v.form1.tarifa.$invalid ? 'is-invalid' : 'is-valid'"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              v-if="
                $store.getters.can('plantaEx.contratos.edit') &&
                  !$v.form1.$invalid
              "
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Histórico -->
    <div class="modal fade" id="modal_tarifa_historico">
      <div class="modal-dialog modal-xl" v-if="datos_tarifa_historico">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Histórico Tarifa</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal2"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="position-relative p-3 m-2 bg-light"
              style="font-size: 0.85em"
            >
              <div class="row">
                <div class="col-sm-2">
                  <div class="description-block">
                    <h5 class="description-header">
                      ${{ datos_tarifa_historico.tarifa }}
                    </h5>
                    <span class="description-text text-secondary">Tarifa</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="description-block">
                    <h5 class="description-header">
                      {{ datos_tarifa_historico.tipo_producto }}
                    </h5>
                    <span class="description-text text-secondary"
                      >Tipo Producto</span
                    >
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="description-block">
                    <h5 class="description-header">
                      {{ datos_tarifa_historico.tipo_vehiculo }}
                    </h5>
                    <span class="description-text text-secondary"
                      >Tipo Vehículo</span
                    >
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="description-block">
                    <h5 class="description-header">
                      {{ datos_tarifa_historico.porcentaje_disponibilidad }}%
                    </h5>
                    <span class="description-text text-secondary"
                      >% Disponibilidad</span
                    >
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="description-block">
                    <h5 class="description-header">
                      {{ datos_tarifa_historico.inicio_vigencia }}
                    </h5>
                    <span class="description-text text-secondary"
                      >Fecha Inicial</span
                    >
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="description-block">
                    <h5 class="description-header">
                      {{ datos_tarifa_historico.fin_vigencia }}
                    </h5>
                    <span class="description-text text-secondary"
                      >Fecha Final</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <h5>Actualizar Vigencia</h5>
            <div class="row">
              <div class="form-group col-md-3">
                <label>Fecha Inicio</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form2.inicio_vigencia"
                  :class="
                    $v.form2.inicio_vigencia.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                  @change="validarFechas()"
                />
              </div>
              <div class="form-group col-md-3">
                <label>Fecha Fin</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form2.fin_vigencia"
                  :class="
                    $v.form2.fin_vigencia.$invalid ? 'is-invalid' : 'is-valid'
                  "
                  @change="validarFechas()"
                />
              </div>
              <div class="form-group col-md-2 pt-4 text-right">
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#modal_tarifa"
                  class="btn btn-primary btn-sm"
                  @click="save()"
                  v-if="
                    $store.getters.can('plantaEx.contratos.edit') &&
                      !$v.form2.$invalid
                  "
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body table-responsive">
            <table
              class="
                table table-bordered table-striped table-hover
                text-nowrap
                table-sm
              "
            >
              <thead class="thead-dark">
                <tr>
                  <th class="text-center" style="width: 120px">Estado</th>
                  <th class="text-center">Tarifa</th>
                  <th class="text-center">Fecha Ini</th>
                  <th class="text-center">Fecha Fin</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="det in tarifa_historico" :key="det.id">
                  <td class="text-center">
                    <span
                      class="badge"
                      :class="
                        det.estado == 1 ? 'badge-success' : 'badge-danger'
                      "
                      >{{ det.nEstado }}</span
                    >
                  </td>
                  <td class="text-right">${{ det.tarifa }}</td>
                  <td class="text-right">{{ det.inicio_vigencia }}</td>
                  <td class="text-right">{{ det.fin_vigencia }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para importar tarifas -->
    <div class="modal fade" id="modal_importar_tarifas_interno">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-info pt-2 pb-2">
            <h4 class="modal-title text-white">Importar Tarifas</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              <h5><i class="icon fas fa-info"></i> Instrucciones:</h5>
              <ul class="mb-0">
                <li>
                  Use <strong>Exportar</strong> para descargar las tarifas
                  actuales y editarlas en Excel.
                </li>
                <li>
                  <strong>Para actualizar:</strong> Mantenga la columna
                  ID_TARIFA de la fila existente.
                </li>
                <li>
                  <strong>Para crear nueva:</strong> Deje ID_TARIFA vacío; se
                  crea la tarifa con detalle en estado activo (1).
                </li>
                <li>
                  Columnas: TIPO_PRODUCTO, TIPO_VEHICULO,
                  PORCENTAJE_DISPONIBILIDAD, TARIFA, FECHA_INI, FECHA_FIN
                  (listas filtradas a línea de negocio 17).
                </li>
                <li>
                  Fechas en formato <strong>YYYY-MM-DD</strong> (igual que la
                  fila exportada).
                </li>
              </ul>
            </div>
            <div class="form-group">
              <label for="archivo_tarifas_interno"
                >Archivo Excel (.xlsx o .xls)</label
              >
              <input
                type="file"
                class="form-control-file"
                id="archivo_tarifas_interno"
                ref="archivoTarifas"
                accept=".xlsx,.xls"
                @change="validarArchivoImport"
              />
              <small class="form-text text-muted">Tamaño máximo: 10MB</small>
            </div>
            <div v-if="archivoValido" class="alert alert-success">
              <i class="fas fa-check-circle"></i> Archivo válido:
              {{ nombreArchivo }}
            </div>
            <div v-if="errorArchivo" class="alert alert-danger">
              <i class="fas fa-exclamation-triangle"></i> {{ errorArchivo }}
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="!archivoValido || importando"
              @click="importarTarifas()"
            >
              <i class="fas fa-upload"></i>
              {{ importando ? "Importando..." : "Subir" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PlantTarifa",
  components: {},
  data() {
    return {
      cargando: false,
      tarifa_index: null,
      form: {
        id: null,
        plant_contrato_id: this.$parent.id,
        tarifa: null,
        tipo_producto_id: null,
        tipo_vehiculo_id: null,
        porcentaje_disponibilidad: null,
        inicio_vigencia: null,
        fin_vigencia: null,
      },
      form1: {
        id: null,
        plant_contrato_id: this.$parent.id,
        plant_det_tarifa_id: null,
        tarifa: null,
        tipo_producto_id: null,
        tipo_vehiculo_id: null,
        porcentaje_disponibilidad: null,
      },
      form2: {
        id: null,
        plant_contrato_id: this.$parent.id,
        tarifa: null,
        tipo_producto_id: null,
        tipo_vehiculo_id: null,
        porcentaje_disponibilidad: null,
        inicio_vigencia: null,
        fin_vigencia: null,
      },
      listasForms: {
        sitios: [],
        estados: {},
      },
      datos_tarifa_historico: [],
      tarifa_historico: [],
      archivoValido: false,
      nombreArchivo: "",
      errorArchivo: "",
      importando: false,
    };
  },
  validations() {
    return {
      form: {
        tarifa: { required },
        tipo_producto_id: { required },
        tipo_vehiculo_id: { required },
        porcentaje_disponibilidad: { required },
        inicio_vigencia: { required },
        fin_vigencia: { required },
      },
      form1: {
        tarifa: { required },
        tipo_producto_id: { required },
        tipo_vehiculo_id: { required },
        porcentaje_disponibilidad: { required },
      },
      form2: {
        inicio_vigencia: { required },
        fin_vigencia: { required },
      },
    };
  },
  methods: {
    getDatosModal(tarifa = null) {
      this.$parent.cargando = true;
      this.resetForm();
      if (tarifa) {
        const det_tarifa = tarifa.det_tarifas[0];
        this.form1 = {
          id: tarifa.id,
          plant_contrato_id: tarifa.plant_contrato_id,
          plant_det_tarifa_id: det_tarifa.id,
          tarifa: det_tarifa.tarifa,
          tipo_producto_id: tarifa.tipo_producto_id,
          tipo_vehiculo_id: tarifa.tipo_vehiculo_id,
          porcentaje_disponibilidad: tarifa.porcentaje_disponibilidad,
        };
      }
      this.$parent.cargando = false;
    },

    getDatosHistorico(tarifa, index) {
      this.resetForm();
      this.tarifa_index = index;
      const det_tarifa = tarifa.det_tarifas[0];
      this.form2 = {
        id: tarifa.id,
        plant_contrato_id: tarifa.plant_contrato_id,
        plant_det_tarifa_id: det_tarifa.id,
        tarifa: det_tarifa.tarifa,
        tipo_producto_id: tarifa.tipo_producto_id,
        tipo_vehiculo_id: tarifa.tipo_vehiculo_id,
        porcentaje_disponibilidad: tarifa.porcentaje_disponibilidad,
      };
      this.datos_tarifa_historico = {
        tarifa: det_tarifa.tarifa,
        tipo_producto: tarifa.tipo_producto
          ? tarifa.tipo_producto.nombre
          : "—",
        tipo_vehiculo: tarifa.tipo_vehiculo
          ? tarifa.tipo_vehiculo.nombre
          : "—",
        porcentaje_disponibilidad: tarifa.porcentaje_disponibilidad,
        inicio_vigencia: det_tarifa.inicio_vigencia,
        fin_vigencia: det_tarifa.fin_vigencia,
      };
      this.tarifa_historico = tarifa.det_tarifas;
    },

    resetForm() {
      this.tarifa_index = null;
      this.form = {
        id: null,
        plant_contrato_id: this.$parent.id,
        tarifa: null,
        tipo_producto_id: null,
        tipo_vehiculo_id: null,
        porcentaje_disponibilidad: null,
        inicio_vigencia: null,
        fin_vigencia: null,
      };
      this.form1 = {
        id: null,
        plant_contrato_id: this.$parent.id,
        plant_det_tarifa_id: null,
        tarifa: null,
        tipo_producto_id: null,
        tipo_vehiculo_id: null,
        porcentaje_disponibilidad: null,
      };
      this.form2 = {
        id: null,
        plant_contrato_id: this.$parent.id,
        tarifa: null,
        tipo_producto_id: null,
        tipo_vehiculo_id: null,
        porcentaje_disponibilidad: null,
        inicio_vigencia: null,
        fin_vigencia: null,
      };
    },

    async validarFechas() {
      await this.validaVigenciaContrato();
      await this.validaFechasVigencia();
      if (this.form.id || this.form2.id) {
        await this.validaFechasTarifa();
      }
    },

    validaVigenciaContrato() {
      const inicio_contrato = this.$parent.form.fecha_ini;
      const fin_contrato = this.$parent.form.fecha_fin;
      if (this.form.inicio_vigencia) {
        if (
          !this.validaFechas(inicio_contrato, this.form.inicio_vigencia) ||
          !this.validaFechas(this.form.inicio_vigencia, fin_contrato)
        ) {
          this.form.inicio_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Inicio de la Tarifa se encuentra fuera de las fechas estipuladas en el contrato...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.form.fin_vigencia) {
        if (
          !this.validaFechas(inicio_contrato, this.form.fin_vigencia) ||
          !this.validaFechas(this.form.fin_vigencia, fin_contrato)
        ) {
          this.form.fin_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Fin de la Tarifa se encuentra fuera de las fechas estipuladas en el contrato...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.form2.inicio_vigencia) {
        if (
          !this.validaFechas(inicio_contrato, this.form2.inicio_vigencia) ||
          !this.validaFechas(this.form2.inicio_vigencia, fin_contrato)
        ) {
          this.form2.inicio_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Inicio de la Tarifa se encuentra fuera de las fechas estipuladas en el contrato...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.form2.fin_vigencia) {
        if (
          !this.validaFechas(inicio_contrato, this.form2.fin_vigencia) ||
          !this.validaFechas(this.form2.fin_vigencia, fin_contrato)
        ) {
          this.form2.fin_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Fin de la Tarifa se encuentra fuera de las fechas estipuladas en el contrato...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },

    validaFechasVigencia() {
      if (this.form.inicio_vigencia && this.form.fin_vigencia) {
        if (
          !this.validaFechas(this.form.inicio_vigencia, this.form.fin_vigencia)
        ) {
          this.form.fin_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Inicio de la Tarifa no puede ser mayor a la Fecha Fin...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
      if (this.form2.inicio_vigencia && this.form2.fin_vigencia) {
        if (
          !this.validaFechas(
            this.form2.inicio_vigencia,
            this.form2.fin_vigencia,
          )
        ) {
          this.form2.fin_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha Inicio de la Tarifa no puede ser mayor a la Fecha Fin...`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    },

    validaFechasTarifa() {
      if (this.form.inicio_vigencia) {
        const fecha_fin_det_tarifa = this.$parent.form.tarifas[0].det_tarifas[0]
          .fin_vigencia;
        if (
          !this.validaFechas(fecha_fin_det_tarifa, this.form.inicio_vigencia)
        ) {
          this.form.inicio_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha de Inicio se cruza con la vigencia de la tarifa actual, favor poner una fecha posterior a ${fecha_fin_det_tarifa}.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      }
      if (this.form2.inicio_vigencia) {
        const fecha_fin_det_tarifa = this.$parent.form.tarifas[
          this.tarifa_index
        ].det_tarifas[0].fin_vigencia;
        if (
          !this.validaFechas(fecha_fin_det_tarifa, this.form2.inicio_vigencia)
        ) {
          this.form2.inicio_vigencia = null;
          this.$swal({
            icon: "error",
            title: `La Fecha de Inicio se cruza con la vigencia de la tarifa actual, favor poner una fecha posterior a ${fecha_fin_det_tarifa}.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      }
    },

    validaFechas(fecha_menor, fecha_mayor) {
      fecha_menor = new Date(fecha_menor);
      fecha_mayor = new Date(fecha_mayor);
      if (fecha_menor > fecha_mayor) {
        return false;
      }
      return true;
    },

    save() {
      this.$parent.cargando = true;

      let form = null;
      let method = null;
      if (!this.$v.form.$invalid) {
        method = `POST`;
        form = this.form;
      }
      if (!this.$v.form1.$invalid) {
        method = `PUT`;
        form = this.form1;
      }
      if (!this.$v.form2.$invalid) {
        method = `POST`;
        form = this.form2;
      }

      if (form) {
        axios({
          method,
          url: "/api/plant/contratos/tarifas",
          data: form,
        })
          .then((response) => {
            this.$parent.cargando = false;
            this.$parent.form.tarifas = response.data.tarifas;
            this.$refs.closeModal.click();
            this.$refs.closeModal1.click();
            this.$refs.closeModal2.click();

            this.$swal({
              icon: "success",
              title: "La tarifa se guardó exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.resetForm();
          })
          .catch((e) => {
            this.$parent.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(tarifa) {
      this.$swal({
        title: "Está seguro de eliminar esta Tarifa?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          axios
            .delete("/api/plant/contratos/tarifas/" + tarifa.id)
            .then((response) => {
              this.$parent.cargando = false;
              this.$parent.form.tarifas = response.data.tarifas;
              this.$swal({
                icon: "success",
                title: "Se eliminó la Tarifa exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    exportarTarifas() {
      this.$parent.cargando = true;
      const url = `/api/plant/contratos/tarifas/export/${this.$parent.id}`;
      axios({ method: "GET", url, responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = `tarifas_contrato_${
            this.$parent.id
          }_${new Date().toISOString().slice(0, 10)}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
          this.$parent.cargando = false;
          this.$swal({
            icon: "success",
            title: "Archivo exportado correctamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.$parent.cargando = false;
          let msg = "Error al exportar las tarifas";
          if (error.response && error.response.data) {
            if (typeof error.response.data === "string") {
              try {
                const d = JSON.parse(error.response.data);
                if (d.error) msg = d.error;
              } catch (_) {
                // mantener msg por defecto
              }
            } else if (error.response.data.error)
              msg = error.response.data.error;
          }
          this.$swal({
            icon: "error",
            title: "Error",
            text: msg,
            showConfirmButton: true,
          });
        });
    },

    abrirModalImportar() {
      this.archivoValido = false;
      this.nombreArchivo = "";
      this.errorArchivo = "";
      this.importando = false;
      if (this.$refs.archivoTarifas) this.$refs.archivoTarifas.value = "";
      this.$nextTick(() => {
        const modal = document.getElementById("modal_importar_tarifas_interno");
        if (modal && window.$) window.$(modal).modal("show");
      });
    },

    validarArchivoImport(event) {
      this.archivoValido = false;
      this.errorArchivo = "";
      this.nombreArchivo = "";
      const file = event.target.files[0];
      if (!file) return;
      const ext = file.name.split(".").pop().toLowerCase();
      if (!["xlsx", "xls"].includes(ext)) {
        this.errorArchivo = "Solo se permiten archivos Excel (.xlsx, .xls)";
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.errorArchivo = "El archivo no debe superar 10MB";
        return;
      }
      this.archivoValido = true;
      this.nombreArchivo = file.name;
    },

    importarTarifas() {
      if (!this.archivoValido || !this.$refs.archivoTarifas.files[0]) return;
      this.importando = true;
      this.$parent.cargando = true;
      const formData = new FormData();
      formData.append("archivo", this.$refs.archivoTarifas.files[0]);
      axios
        .post(
          `/api/plant/contratos/tarifas/import/${this.$parent.id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        .then((response) => {
          this.importando = false;
          this.$parent.cargando = false;
          if (response.data.data && response.data.data.tarifas) {
            this.$parent.form.tarifas = response.data.data.tarifas;
          }
          const modal = document.getElementById(
            "modal_importar_tarifas_interno",
          );
          if (modal && window.$) window.$(modal).modal("hide");
          this.$swal({
            icon: "success",
            title: response.data.message || "Tarifas importadas correctamente",
            text:
              response.data.data &&
              `Nuevas: ${response.data.data.nuevas || 0} | Actualizadas: ${
                response.data.data.actualizadas || 0
              }`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.importando = false;
          this.$parent.cargando = false;
          let msg = "Error al importar tarifas";
          if (error.response && error.response.data) {
            if (error.response.data.error) msg = error.response.data.error;
            else if (error.response.data.message)
              msg = error.response.data.message;
          }
          this.$swal({
            icon: "error",
            title: "Error",
            text: msg,
            showConfirmButton: true,
          });
        });
    },
  },
};
</script>
